enum EmployeeGroupTypeEnum {
  Unknown = "unknown",
  Listing = "listing",
  Census = "census",
}

export { EmployeeGroupTypeEnum };
